// Level colors for row (R) and column (K) dimensions
// Each level gets a distinct color for visual connection between chips and pivot table
export const ROW_LEVEL_COLORS = [
  { bg: 'bg-blue-100', text: 'text-blue-700', border: 'border-blue-300', label: 'R1' },
  { bg: 'bg-amber-100', text: 'text-amber-700', border: 'border-amber-300', label: 'R2' },
  { bg: 'bg-emerald-100', text: 'text-emerald-700', border: 'border-emerald-300', label: 'R3' },
  { bg: 'bg-purple-100', text: 'text-purple-700', border: 'border-purple-300', label: 'R4' },
];

export const COL_LEVEL_COLORS = [
  { bg: 'bg-rose-100', text: 'text-rose-700', border: 'border-rose-300', label: 'K1' },
  { bg: 'bg-cyan-100', text: 'text-cyan-700', border: 'border-cyan-300', label: 'K2' },
  { bg: 'bg-orange-100', text: 'text-orange-700', border: 'border-orange-300', label: 'K3' },
];

// Entity-specific friendly labels so users know exactly what field they're looking at
// Avoids confusion like "Type" (asset type? building type? unit type?)
export const ENTITY_LABELS: Record<string, string> = {
  'assetCategory.name': 'Voorziening > Categorie',
  'assetType.name': 'Voorziening > Type',
  'status': 'Voorziening > Status',
  'name': 'Voorziening > Naam',
  'building.googlePlaceLongAddress': 'Gebouw > Adres',
  'building.id': 'Gebouw > ID',
  'building.location.city.name': 'Gebouw > Stad',
  'building.location.city.zip': 'Gebouw > Postcode',
  'building.location.city.province': 'Gebouw > Provincie',
  'building.company.name': 'Gebouw > Vennootschap',
  'unit.id': 'Unit > ID',
  'unit.unitType': 'Unit > Type',
  'unit.unitSubtype': 'Unit > Subtype',
  'installer.name': 'Onderhoud > Installateur',
  'location': 'Voorziening > Locatie',
  'installationDate': 'Voorziening > Installatiedatum',
  'warrantyExpiryDate': 'Voorziening > Garantie verloop',
  'lastMaintenanceDate': 'Onderhoud > Laatste datum',
  'nextMaintenanceDate': 'Onderhoud > Volgende datum',
  'createdAt': 'Voorziening > Aanmaakdatum',
};

export function getEntityLabel(field: string, fallback: string): string {
  return ENTITY_LABELS[field] || fallback;
}
